module.exports = __webpack_public_path__ + "static/media/carrot-logo-black.31b58b20.png";